<template>
  <p class="player">
    <span class="player_infos__name">
      {{ player.lastName }}
    </span>
    <span class="player_infos__additionnal__goals">
      <goals-display :player="player" small-icons />
    </span>
    <span class="player__rating">
      {{ player.rating ? player.getTotalScore() : "-" }}
      <player-status class="player__rating__status" :player="player" />
    </span>
    <span class="player__substitution_icon">
      <substitution-icon is-out />
    </span>
  </p>
</template>

<script setup>
import GoalsDisplay from "@/components/goals/GoalsDisplay.vue";
import SubstitutionIcon from "@/components/icons/SubstitutionIcon.vue";
import PlayerStatus from "@/components/player/PlayerStatus.vue";
import { Player } from "@/models/players/Player";

defineProps({
  player: {
    type: Player,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.player {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: start;
  column-gap: 5px;
  font-size: .6em;

  &_infos__name {
    color: #959daf;
  }

  &_infos__additionnal__goals {
    margin-left: 10px;
  }

  &__rating {
    position: relative;
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
    border-radius: 16px;
    height: 14px;
    min-width: 14px;
    padding: 0;
    color: #fff;
    background-color: #959daf;

    &__status {
      position: absolute;
      top: -5px;
      right: -5px;
    }
  }

  &__substitution_icon {
    position: absolute;
    right:-17px;
  }

}
</style>